<template>
  <v-tabs>
    <v-tab><h2>瀏覽</h2></v-tab>
    <v-tab-item class="pa-1 pa-sm-4">
      <!-- Table -->
      <v-row>
        <v-col sm="12" md="9" class="pb-0 pt-0">
          <v-data-table
            :headers="headers"
            item-key="quote_id"
            :items="!isSending ? listByOotion : []"
            class="elevation-4 my-quote-table"
            :search="tableSearch"
            :loading="isSending"
            loading-text="資料更新中..."
            no-data-text="暫無資料"
            no-results-text="沒有匹配的資料"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :mobile-breakpoint="tableModes[tableMode].breakpoint"
          >
            <template v-slot:top>
              <v-row v-if="tag === 1" dense>
                <v-col>
                  <v-combobox
                    label="代理帳號"
                    class="mx-4"
                    :items="!isSending ? options1 : []"
                    v-model="optionsSelected1"
                  ></v-combobox>
                </v-col>
                <v-col>
                  <v-combobox
                    label="身份"
                    class="mx-4"
                    :items="!isSending ? options2 : []"
                    v-model="optionsSelected2"
                  ></v-combobox>
                </v-col>
              </v-row>
              <!--  -->
              <v-row dense>
                <v-col>
                  <v-text-field
                    v-model="tableSearch"
                    label="快速搜尋"
                    class="mx-4"
                  ></v-text-field>
                </v-col>
              </v-row>
              <!--  -->
            </template>

            <template v-slot:item.c_name="{ item }">
              {{ item.c_name || contactNames[item.tag] }}
            </template>
            <template v-slot:item.tag="{ item }">
              {{ qouteTags[item.tag] || '' }}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn icon @click="handleOnClickContact(item)">
                <v-icon>
                  mdi-account-box
                </v-icon>
              </v-btn>
              <v-btn icon @click="handleOnClickQuoteList(item)">
                <v-icon>
                  mdi-format-list-bulleted
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-tab-item>
    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h3>聯絡人資料</h3>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field :value="quoteName" label="姓名"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field :value="quotePhone" label="電話"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field :value="quoteLine" label="LineID"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea :value="quoteMaterial" label="匯款資料"></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea :value="quoteMemo" label="備註"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog 2 -->
    <v-dialog v-model="dialog2" max-width="600px">
      <v-card>
        <v-card-title class="pt-1 pl-3 pr-3 pt-sm-4 pl-sm-6 pr-sm-6">
          <v-row>
            <v-col>
              <h3>報價清單</h3>
            </v-col>
            <v-col class="text-end">
              <v-btn color="success" @click="handleOnCloseQuote">
                <h3>結算</h3>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pt-1 pl-3 pr-3 pt-sm-4 pl-sm-6 pr-sm-6">
          <v-data-table
            :headers="headers2"
            item-key="quote_list_id"
            class="my-quote-list-table"
            :items="!isSending2 ? quotelist : []"
            :search="tableSearch"
            :loading="isSending2"
            loading-text="資料更新中..."
            :mobile-breakpoint="1"
          >
            <template v-slot:top>
              <!-- <v-row>
                <v-col class="text-end">
                  <v-btn color="success">
                    <h3>結算</h3>
                  </v-btn>
                </v-col>
              </v-row> -->
            </template>
            <template v-slot:body.append>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="my-quote-list-total">{{ quoteTotal }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-tabs>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapActions, mapState } from 'vuex'
export default {
  data: () => ({
    // #region Table
    tableSearch: '',
    headers: [
      { text: '編號', align: 'start', value: 'quote_id' },
      { text: '姓名', align: 'start', value: 'name' },
      { text: '身份', align: 'start', value: 'tag' },
      { text: '總額', align: 'start', value: 'total' },
      { text: '電話', align: 'start', value: 'phone' },
      { text: '日期', align: 'start', value: 'create_date' },
      { text: '', align: 'start', value: 'actions' }
    ],
    qouteTags: {
      2: '代理',
      3: '會員',
      9: '遊客'
    },
    contactNames: {
      2: '未設定',
      3: '未設定',
      9: ''
    },
    sortBy: 'create_date',
    sortDesc: true,
    // #endregion

    // #region Dialog of Contact
    dialog: false,
    quoteName: '',
    quotePhone: '',
    quoteLine: '',
    quoteMaterial: '',
    quoteMemo: '',
    // #endregion

    // #region Dialog of Quote List
    dialog2: false,
    // Table
    quoteId: null,
    quoteTotal: '',
    headers2: [
      {
        text: '品牌',
        align: 'start',
        value: 'b_name',
        sortable: false
      },
      {
        text: '系列',
        align: 'start',
        value: 's_name',
        sortable: false
      },
      {
        text: '型號',
        align: 'start',
        value: 'model',
        sortable: false
      },
      {
        text: '單價',
        align: 'end',
        value: 'u_price',
        sortable: false
      },
      {
        text: '數量',
        align: 'end',
        value: 'amount',
        sortable: false
      },
      {
        text: '小計',
        align: 'end',
        value: 's_total',
        sortable: false
      }
    ],
    // #endregion

    // #region Combobox
    options1: [
      { text: '管理員', value: -1 },
      { text: '所有代理商會員', value: 0 }
    ],
    optionsSelected1: '',
    options2: [
      { text: '全部', value: 0 },
      { text: '代理', value: 2 },
      { text: '會員', value: 3 },
      { text: '遊客', value: 9 }
    ],
    optionsSelected2: { text: '全部', value: 0 },
    // #endregion

    // #region
    // #endregion
    nothing: undefined
  }),
  computed: {
    ...mapState('account', ['tag', 'ag_id', 'level', 'user', 'uid']),
    // eslint-disable-next-line prettier/prettier
    ...mapState('admin', ['tableModes', 'tableMode', 'quotes', 'quotelist', 'quoteAgents', 'isSending', 'isSending2']),
    listByOotion() {
      const o = []

      if (this.tag === 2) return this.quotes

      if (!this.optionsSelected1) return o
      if (this.optionsSelected1.value === undefined) return o
      if (!this.optionsSelected2) return o
      if (this.optionsSelected2.value === undefined) return o

      const o1_id = this.optionsSelected1.value
      const o2_id = this.optionsSelected2.value

      this.quotes.forEach(e => {
        if (
          o1_id === -1 &&
          (e.agent_id === '' || e.agent_id === '0') &&
          (o2_id === 0 || o2_id === e.tag)
        ) {
          o.push(e)
        } else if (o1_id === 0 && e.agent_id * 1 > 0) {
          o.push(e)
        } else if (o1_id === e.agent_id * 1 && e.agent_id * 1 > 0) {
          o.push(e)
        }
      })

      return o
    }
  },
  methods: {
    ...mapActions('admin', ['getAllQuotes', 'getQuoteList', 'closeQuote']),
    handleOnClickContact(item) {
      this.quoteName = item.name
      this.quotePhone = item.phone
      this.quoteLine = item.line
      this.quoteMaterial = item.material
      this.quoteMemo = item.memo
      this.dialog = true
    },

    handleOnClickQuoteList(item) {
      this.quoteTotal = ''
      this.dialog2 = true
      ;(async () => {
        const { ag_id, level, user, uid } = this
        await this.getQuoteList({
          quote_id: item.quote_id,
          ag_id,
          level,
          user,
          uid
        })
        this.quoteId = item.quote_id
        this.quoteTotal = item.total
      })()
    },

    handleOnCloseQuote() {
      this.dialog2 = false
      ;(async () => {
        const { ag_id, level, user, uid } = this
        await this.closeQuote({
          ag_id,
          quote_id: this.quoteId,
          level,
          user,
          uid
        })
      })()
    },

    nothingMethod() {}
  },
  created() {
    this.$emit('setTopLabel', 6)
    //
    ;(async () => {
      const { ag_id, level, user, uid } = this
      await this.getAllQuotes({ ag_id, level, user, uid })
      this.quoteAgents.forEach(e => {
        this.options1.push(e)
      })

      this.optionsSelected1 = this.options1[0]
    })()
  }
}
</script>

<style lang="scss">
.my-quote-table,
.my-quote-list-table {
  th,
  td {
    font-size: 18px;
  }

  th {
    white-space: nowrap;
  }
}

.my-quote-list-table {
  .my-quote-list-total {
    text-align: right !important;
  }
  // .my-quote-list-total,
  // table tbody tr .text-start:nth-child(n + 3) {
  //   text-align: right !important;
  //   padding-right: 34px;
  // }
}

.my-quote-table {
  table thead tr .text-start:nth-child(4) {
    width: 90px !important;
  }

  table tbody tr .text-start:nth-child(4) {
    text-align: right !important;
  }
}

@media screen and (max-width: 600px) {
  .my-quote-table,
  .my-quote-list-table {
    .v-input {
      label,
      input {
        font-size: 20px;
      }
    }

    // th {
    //   vertical-align: top !important;
    // }

    th,
    td {
      padding-right: 2px !important;
      padding-left: 4px !important;
    }

    .v-data-footer {
      .v-data-footer__select {
        margin-right: 0px;
      }
    }
  }
}
</style>
